import { RouteComponentProps, useNavigate } from '@reach/router';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled, Theme } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import { useSettings } from '../../hooks/useSettings/useSettings';
import QuoteWizardState from '../../store/QuoteWizardState';
import { resetAxisState } from '../../store/axisStore';
import { AxisLogo } from './components/AxisLogo';

export const AxisBasicInformationThankYou = (_props: RouteComponentProps) => {
  const { settings } = useSettings();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleBackToHome = () => {
    dispatch(QuoteWizardState.actions.resetSelections(['questionsPerPage']));
    dispatch(resetAxisState());
    navigate('/');
  };

  return (
    <ThankYouOuter>
      <AxisLogo />
      <ThankYouContent>
        <ThankYouHeading>
          Thank you for taking the time to fill out our application forms!
        </ThankYouHeading>
        <ThankYouBody>
          {settings.thankYouText
            ? settings.thankYouText
            : 'Someone from our team will be in touch with you in the next 24-48 hours.'}
        </ThankYouBody>
        <ThankYouButtonContainer>
          <BackNavigationButton type='button' onClick={handleBackToHome}>
            Back to Home
          </BackNavigationButton>
        </ThankYouButtonContainer>
      </ThankYouContent>
    </ThankYouOuter>
  );
};

const ThankYouOuter = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '60vh',
});

const ThankYouContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  maxWidth: '40rem',
  margin: 'auto',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
}));

const ThankYouHeading = styled(Typography)(({ theme }) => ({
  ...theme.typography.h6,
  color: theme.palette.primary.main,
}));

const ThankYouBody = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1,
}));

const ThankYouButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  width: '100%',
  marginTop: theme.spacing(1),
}));

const BackNavigationButton = styled('button')(({ theme }) =>
  backNavigationStyles(theme),
);

const backNavigationStyles = (theme: Theme) => ({
  ...theme.typography.button,
  display: 'inline-block',
  color: theme.palette.primary.main,
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: 'transparent',
  padding: `${theme.spacing(0.75)} ${theme.spacing(2)}`,
  textTransform: 'none' as const,
  textDecoration: 'none',
  borderRadius: theme.shape.borderRadius,
  cursor: 'pointer',
  font: 'inherit',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    borderColor: theme.palette.primary.main,
  },
});
